module.exports = __webpack_public_path__ + "img/HQ-PS24-V2_V10.7cc9faec.jpg";